module.exports = __webpack_public_path__ + "static/media/review.c2942e2f.png";